import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {IconsLoaderService} from '../services/icons-loader.service';

export const loadIconsGuard: CanActivateFn = (): boolean => {
  const iconsLoader: IconsLoaderService = inject(IconsLoaderService);

  iconsLoader.loadIcons();

  return true;
};
